export const privateStaticPages = ['Influencer FAQ'];
